const state = {
  modalOpen: false
}

const actions = {
}

const mutations = {
  SET_MODAL_OPEN (state) {
    state.modalOpen = true
  },
  SET_MODAL_CLOSED (state) {
    state.modalOpen = false
  }
}

export default {
  state,
  actions,
  mutations
}
